import { Container } from 'react-bootstrap';

function About() {
  return (
    <Container className="mt-5">
      <h2>Tippin White Grizzly's Meadow</h2>
      <p>To keep track of things</p>
      <ul>
        <li>Passport</li>
        <li>Wallet</li>
        <li>...that's all you need</li>
      </ul>
    </Container>
  );
}

export default About; 